import { createContext } from "react";

/**
 * Sends a message as the user, for a component that carries a button. Resolves to null once sent, or
 * to why it was not. Null where nothing can be sent: a read-only session, a run in progress, a
 * session someone else holds.
 */
export const ChatSend = createContext<((text: string) => Promise<string | null>) | null>(null);
